import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../components/Loader"; // Importación
import "../styles/AgenciaDetalle.css"; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

export default function AgenciaDetalle() {
  const { id } = useParams();
  const [agencia, setAgencia] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/agencia/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("No encontrada");
        return res.json();
      })
      .then((data) => setAgencia(data))
      .catch(() => navigate("/"));
  }, [id, navigate]);

  // Implementación del Loader
  if (!agencia) return <Loader message="Cargando detalles de la agencia..." />;

  const dias = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];

  return (
    <div className="detalle-container">
      <div className="header">
        <h2>DETALLES DE LA EMPRESA</h2>
        <button className="cerrar-btn" onClick={() => navigate(-1)}>✕</button>
      </div>

      <div className="detalle-content">
        <div className="izquierda">
          <img 
            className="logo" 
            src={agencia.urlImagen || "/assets/logo_placeholder.png"} 
            alt={`Logo de ${agencia.nombre}`} 
            referrerPolicy="no-referrer" 
          />
          <h3>{agencia.nombre}</h3>

          <div className="seccion">
            <h4>📌 Acerca de</h4>
          </div>

          <div className="seccion">
            <h4>🕒 Horario de atención</h4>
            <table className="horario">
              <tbody>
                {dias.map((dia) => {
                  const horarios = agencia.horario?.[dia];
                  if (!horarios || horarios.length === 0) {
                    return (
                      <tr key={dia}>
                        <td>{capitalize(dia)}</td>
                        <td className="cerrado">cerrado</td>
                      </tr>
                    );
                  }

                  return horarios.map((h, index) => (
                    <tr key={`${dia}-${index}`}>
                      <td>{index === 0 ? capitalize(dia) : ""}</td>
                      <td>{h.abre} - {h.cierra}</td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="derecha">
          <p>📍 {agencia.direccion}</p>
          <p>📞 {agencia.telefono}</p>
          <p>📧 {agencia.correoElectronico}</p>
          {agencia.web && (
            <p>🌐 <a href={agencia.web} target="_blank" rel="noreferrer">{agencia.web}</a></p>
          )}
          <p>⭐ <strong>Puntuación:</strong> <span className="estrellas">★★★★★</span></p>
          <p>💬 Opiniones (0)</p>
          <div className="social-icons">
            <i className="fa-brands fa-facebook-f" />
            <i className="fa-brands fa-twitter" />
            <i className="fa-brands fa-instagram" />
          </div>
        </div>
      </div>
    </div>
  );
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}